import { render, staticRenderFns } from "./CardRegistrosxUsuario.vue?vue&type=template&id=17e2f079"
import script from "./CardRegistrosxUsuario.vue?vue&type=script&lang=js"
export * from "./CardRegistrosxUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports